<h1 class="mb-4">
  <mdb-icon fas icon="cog"></mdb-icon> Reporte Ventas General
</h1>
<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Reportes y Consulta</span>
      <span> /</span>
      <span class="grey-text">Ventas</span>
      <span> /</span>
      <span>Reporte Ventas General</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<form autocomplete="off" [formGroup]="formHeader">
  <div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">
      <div class="row filtros-body">
        <div class="col" style="max-width: 150px">
          <div class="md-form">
            <mdb-select [options]="optionsMonth" [filterEnabled]="true" [highlightFirst]="false" placeholder="Mes"
              formControlName="mes"></mdb-select>
            <label>Mes</label>
            <div
              *ngIf="formHeader.get('mes').invalid && (formHeader.get('mes').dirty || formHeader.get('mes').touched)">
              <mdb-error *ngIf="formHeader.get('mes').hasError('required')">Ingrese mes </mdb-error>
            </div>
          </div>
        </div>
        <div class="col" style="max-width: 100px">
          <div class="md-form">
            <mdb-select [options]="optionsYear" [filterEnabled]="true" [highlightFirst]="false" placeholder="Año"
              formControlName="anho"></mdb-select>
            <label>Año</label>
            <div
              *ngIf="formHeader.get('anho').invalid && (formHeader.get('anho').dirty || formHeader.get('anho').touched)">
              <mdb-error *ngIf="formHeader.get('anho').hasError('required')">Ingrese año </mdb-error>
            </div>
          </div>
        </div>
        <div class="col" style="max-width: 330px">
          <span>Buscar por Cliente: </span>
          <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
            (click)="abrirModalSeleccion()">
            <mdb-icon fas icon="search"></mdb-icon>
          </button>
          <button mdbBtn type="button" class="" color="info" mdbWavesEffect
            (click)="abrirModalSeleccionarClienteSeleccionados()" *ngIf="clientesSeleccionados?.length > 0">
            ({{ clientesSeleccionados.length | numerico }}) Seleccionados
          </button>
          <!-- <h6 class="text-info" style="display: contents;">
                    Nombre de cliente
                  </h6> -->
        </div>
        <div class="col" style="display: flex; align-items: center; max-width: 210px">
          <mdb-checkbox class="ml-3" [checked]="true" formControlName="incl_cliente_inactivos">Incluir Clientes
            Inactivos</mdb-checkbox>
        </div>
        <div class="col" style="display: flex; align-items: center; max-width: 210px">
          <mdb-checkbox formControlName="cliente_sin_venta">Clientes sin venta</mdb-checkbox>
        </div>
        <div class="col" style="display: flex; align-items: center; max-width: 250px">
          <div class="form-check">
            <input type="radio" class="form-check-input" id="materialChecked" mdbInput formControlName="tipoVista"
              [value]="RB_TIPO_VISTA_6" />
            <label class="form-check-label" for="materialChecked">Últimos 6 meses</label>
          </div>
        </div>

        <!-- Material unchecked -->
        <div class="col" style="display: flex; align-items: center; max-width: 250px">
          <div class="form-check">
            <input type="radio" class="form-check-input" id="materialUnchecked" mdbInput formControlName="tipoVista"
              [value]="RB_TIPO_VISTA_12" />
            <label class="form-check-label" for="materialUnchecked">Últimos 12 meses</label>
          </div>
        </div>
      </div>
      <div class="row filtros-body">
        <div class="col" style="max-width: 300px">
          <div class="md-form">
            <mdb-select [options]="optionsRubro" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Seleccione Rubro" formControlName="listaRubro" selectAllLabel="TODOS"></mdb-select>
            <label>Rubro</label>
          </div>
        </div>

        <div class="col" style="max-width: 200px" *ngIf="permiteVerMixtura">
          <div class="md-form">
            <mdb-select label="Mixtura" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              [options]="optionsMixtura" placeholder="Seleccione Mixtura" [filterEnabled]="true" selectAllLabel="TODOS"
              formControlName="listaMixtura">
            </mdb-select>
          </div>
        </div>
      </div>
    </div>

    <!-- FOOTER -->
    <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6">
      <div class="resultados pl-2"></div>
      <div>
        <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="LimpiarData()">Limpiar</button>
        <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect
          (click)="reporteGeneralBuscarNotificacion()">
          <mdb-icon fas icon="search"></mdb-icon>
          Buscar
        </button>
      </div>
    </div>
  </div>
</form>

<!-- Alerta de solicitud enviada -->
<div *ngIf="!loading && listaMovimientos?.length === 0 && listaMovimientosAll?.length === 0" #alert
  class="alert alert-info alert-dismissible fade show m-0" role="alert">
  <button type="button" class="close" aria-label="Close" (click)="closeAlert()">
    <span aria-hidden="true">&times;</span>
  </button>
  <strong>Se ha enviado la solicitud!</strong> En breve minutos llegara la notificacion para descagar el reporte.
</div>

<!-- Listado -->
<div class="card mb-2 wow" *ngIf="listaMovimientosAll && listaMovimientosAll.length > 0">
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <div class="table-responsive">
      <table class="table table-striped table-hover table-sm align-middle" *ngIf="listaMovimientosAll">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">RUT</th>
            <th scope="col">Nombre</th>
            <th scope="col" class="text-center">Estado Cli.</th>
            <th scope="col">Dirección</th>
            <!-- <th scope="col">Ciudad</th> -->
            <th scope="col">Comuna</th>
            <th scope="col" class="text-center">Estado Dir.</th>
            <th scope="col">Telefono</th>
            <th scope="col" *ngIf="permiteVerMixtura">Mixtura</th>
            <th scope="col" class="text-center">Bloq.</th>
            <th scope="col">F. Bloqueo</th>

            <th scope="col">Cod. Vend.</th>
            <th scope="col">Vendedor</th>
            <th scope="col">Cod. Ruta</th>
            <!-- <th scope="col">Ruta</th> -->
            <th scope="col">Territorio</th>
            <!-- <th scope="col">Zona</th> -->
            <th scope="col">Última Venta</th>
            <th scope="col">F. Ingreso</th>
            <th scope="col" class="text-center">Máq.</th>
            <th scope="col" class="text-center">Sec.</th>
            <th scope="col" class="text-center">Suc.</th>
            <th *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_12" scope="col" class="text-right">{{
              monthsFormatted[11] }}</th>
            <th *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_12" scope="col" class="text-right">{{
              monthsFormatted[10] }}</th>
            <th *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_12" scope="col" class="text-right">{{
              monthsFormatted[9] }}</th>
            <th *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_12" scope="col" class="text-right">{{
              monthsFormatted[8] }}</th>
            <th *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_12" scope="col" class="text-right">{{
              monthsFormatted[7] }}</th>
            <th *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_12" scope="col" class="text-right">{{
              monthsFormatted[6] }}</th>
            <th scope="col" class="text-right">{{ monthsFormatted[5] }}</th>
            <th scope="col" class="text-right">{{ monthsFormatted[4] }}</th>
            <th scope="col" class="text-right">{{ monthsFormatted[3] }}</th>
            <th scope="col" class="text-right">{{ monthsFormatted[2] }}</th>
            <th scope="col" class="text-right">{{ monthsFormatted[1] }}</th>
            <th scope="col" class="text-right">{{ monthsFormatted[0] }}</th>
            <th class="text-right">
              <span *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_6">Total 6 Meses</span>
              <span *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_12">Total 12 Meses</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="100%" style="text-align: center" *ngIf="loading">
              <mdb-spinner spinnerColor="blue"></mdb-spinner>
            </td>
            <td colspan="100%" style="text-align: center" *ngIf="!loading && listaMovimientos?.length === 0">No se
              encontró información</td>
          </tr>
          <tr *ngFor="let mov of listaMovimientos">
            <td>{{ mov.rutFormato | rut }}</td>
            <td style="max-width: 300px; text-overflow: Ellipsis; white-space: nowrap; overflow: hidden">{{ mov.nombre
              }}</td>
            <td>
              <div *ngIf="mov.activo">
                <mdb-badge pill="true" success="true">Activo</mdb-badge>
              </div>
              <div *ngIf="!mov.activo">
                <mdb-badge pill="false" warning="true">Inactivo</mdb-badge>
              </div>
            </td>
            <td>{{ mov.direccion_completa }}</td>
            <!-- <td>{{ mov.nombreprovincia }}</td> -->
            <td>{{ mov.nombrecomuna }}</td>
            <td>
              <div *ngIf="mov.direccion_activa">
                <mdb-badge pill="true" success="true">Activo</mdb-badge>
              </div>
              <div *ngIf="!mov.direccion_activa">
                <mdb-badge pill="false" warning="true">Inactivo</mdb-badge>
              </div>
            </td>
            <td>
              <span>{{mov.telefono}}</span>
            </td>
            <td>
              <span *ngIf="permiteVerMixtura" mdbTooltip="{{mov.list_mixtura}}">{{mov.list_mixtura}}</span>
            </td>
            <td class="text-center">
              <mdb-icon fas icon="circle" class="text-danger" *ngIf="mov.bloqueado"></mdb-icon>
              <mdb-icon fas icon="circle" class="text-success" *ngIf="!mov.bloqueado"></mdb-icon>
            </td>
            <td>{{ mov.fecha_bloqueo | fecha }}</td>
            <td class="text-center">{{ mov.codigo_vendedor }}</td>
            <td>{{ mov.nombreVendedorCobrador }}</td>
            <td class="text-center">{{ mov.ruta_codigo }}</td>
            <!-- <td>{{ mov.ruta_nombre }}</td> -->
            <td>{{ mov.nombreTerritorio }}</td>
            <!-- <td>???</td> -->
            <td>{{ mov.fecha_ultima_venta | fecha }}</td>
            <td>{{ mov.fecha_registro | fecha }}</td>
            <td class="text-center">{{ mov.total_maquina | numerico }}</td>
            <td class="text-center">{{ mov.secuencia }}</td>
            <td class="text-center">{{ mov.sucursal_legacy }}</td>
            <td *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_12" class="text-right">{{ mov.mes12 |
              numerico }}</td>
            <td *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_12" class="text-right">{{ mov.mes11 |
              numerico }}</td>
            <td *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_12" class="text-right">{{ mov.mes10 |
              numerico }}</td>
            <td *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_12" class="text-right">{{ mov.mes9 | numerico
              }}</td>
            <td *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_12" class="text-right">{{ mov.mes8 | numerico
              }}</td>
            <td *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_12" class="text-right">{{ mov.mes7 | numerico
              }}</td>
            <td class="text-right">{{ mov.mes6 | numerico
              }}</td>
            <td class="text-right">{{ mov.mes5 | numerico
              }}</td>
            <td class="text-right">{{ mov.mes4 | numerico
              }}</td>
            <td class="text-right">{{ mov.mes3 | numerico
              }}</td>
            <td class="text-right">{{ mov.mes2 | numerico
              }}</td>
            <td class="text-right">{{ mov.mes1 | numerico
              }}</td>
            <td class="text-right">
              <span *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_6">{{ mov.total_6meses | numerico
                }}</span>
              <span *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_12">{{ mov.total_12meses | numerico
                }}</span>
            </td>
          </tr>
        </tbody>
        <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
          *ngIf="listaMovimientosAll?.length > 0"></app-pagination>
      </table>
    </div>
  </div>
</div>

<div class="card mb-2 wow" *ngIf="listaMovimientos?.length > 0">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <table class="table table-striped table-hover table-sm align-middle">
      <thead class="grey lighten-2">
        <tr>
          <th scope="col"></th>
          <th scope="col" class="text-right">Clientes</th>
          <th scope="col" class="text-right">Maquinas</th>
          <th *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_12" scope="col" class="text-right">{{
            monthsFormatted[11] }}</th>
          <th *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_12" scope="col" class="text-right">{{
            monthsFormatted[10] }}</th>
          <th *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_12" scope="col" class="text-right">{{
            monthsFormatted[9] }}</th>
          <th *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_12" scope="col" class="text-right">{{
            monthsFormatted[8] }}</th>
          <th *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_12" scope="col" class="text-right">{{
            monthsFormatted[7] }}</th>
          <th *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_12" scope="col" class="text-right">{{
            monthsFormatted[6] }}</th>
          <th scope="col" class="text-right">
            {{ monthsFormatted[5] }}
          </th>
          <th scope="col" class="text-right">
            {{ monthsFormatted[4] }}
          </th>
          <th scope="col" class="text-right">
            {{ monthsFormatted[3] }}
          </th>
          <th scope="col" class="text-right">
            {{ monthsFormatted[2] }}
          </th>
          <th scope="col" class="text-right">
            {{ monthsFormatted[1] }}
          </th>
          <th scope="col" class="text-right">
            {{ monthsFormatted[0] }}
          </th>
          <th scope="col" class="text-right">
            <spam *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_6">Total</spam>
            <spam *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_12">Total</spam>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td><strong>Totales</strong></td>
          <td class="text-right">{{ totales.cantidad | numerico }}</td>
          <td class="text-right">{{ totales.maquinas | numerico }}</td>
          <td *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_12" class="text-right">{{ totales.mes1 |
            numerico }}</td>
          <td *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_12" class="text-right">{{ totales.mes2 |
            numerico }}</td>
          <td *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_12" class="text-right">{{ totales.mes3 |
            numerico }}</td>
          <td *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_12" class="text-right">{{ totales.mes4 |
            numerico }}</td>
          <td *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_12" class="text-right">{{ totales.mes5 |
            numerico }}</td>
          <td *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_12" class="text-right">{{ totales.mes6 |
            numerico }}</td>
          <td class="text-right">{{ totales.mes7 |
            numerico }}</td>
          <td class="text-right">{{ totales.mes8 |
            numerico }}</td>
          <td class="text-right">{{ totales.mes9 |
            numerico }}</td>
          <td class="text-right">{{ totales.mes10 |
            numerico }}</td>
          <td class="text-right">{{ totales.mes11 |
            numerico }}</td>
          <td class="text-right">{{ totales.mes12 |
            numerico }}</td>
          <td class="text-right">
            <span *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_6">{{ totales.total6meses | numerico
              }}</span>
            <span *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_12">{{ totales.total12meses | numerico
              }}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div class="card mb-2 wow" *ngIf="listaMovimientos?.length > 0">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <app-api-button (click2)="downloadExcelPdf('XLS')" [processing]="processing">Excel</app-api-button>
  </div>
</div>

<!-- MODAL seleccionarCliente -->
<app-modal-seleccionar-cliente (onSelectMultiple)="onClienteSeleccionadoMultiple($event)" queryType="ONLY_RUT"
  (onSelectSingle)="onClienteSeleccionado($event)"> </app-modal-seleccionar-cliente>